// extracted by mini-css-extract-plugin
export var partnershipCarousel = "partnership-carousel-module--partnershipCarousel--3xC-M";
export var slider = "partnership-carousel-module--slider--1RjsY";
export var slide = "partnership-carousel-module--slide--U5KsU";
export var slideOuter = "partnership-carousel-module--slideOuter--W9eW_";
export var slideInner = "partnership-carousel-module--slideInner--qtxsC";
export var slideImageColumn = "partnership-carousel-module--slideImageColumn--1M1qA";
export var slideImage = "partnership-carousel-module--slideImage--1zg_C";
export var slideLogo = "partnership-carousel-module--slideLogo--1MRQ5";
export var slideCopyColumn = "partnership-carousel-module--slideCopyColumn--vin3T";
export var slideLink = "partnership-carousel-module--slideLink--28IBg";